import {post} from './http-calls';

export const ForgotPassword = async (email)=>{
    let res = await post('/resetPassword', {
        "email": email,
    });
    return res;
}